import { useNumericParams } from '@domain-group/react-hooks'

import PageContent from './components/PageContent'

const Overview = () => {
  const { taskListId } = useNumericParams()

  return (
    <PageContent taskListId={taskListId} />
  )
}

export default Overview
